<template>
  <div v-show="isEnabled('control-panel')" class="top-4 left-4 z-[999] fixed" style="z-index: 9999; top: 1rem; left: 1rem">
    <!-- leave the alt text empty here -->
    <img
      src="/images/logos/fabrique.png"
      role="presentation"
      aria-hidden="true"
      class="h-[50px] w-[50px] hover:brightness-105 hover:shadow-lg cursor-pointer"
      style="height: 50px; width: 50px"
      alt="Fabrique icon"
      :title="t_('enable')"
      @click="toggleDropdown"
    />
    <ul v-show="isOpen" class="border-neutral-300 w-80 absolute bg-white border-2 border-solid shadow-xl" style="z-index: 50; width: 20rem">
      <li v-for="{ label, url } in urls" :key="url">
        <a :href="url" class="hover:bg-neutral-100 flex items-center px-4 py-2 w-full cursor-pointer" target="_top">
          <AtomIconPencil class="shrink-0 mr-3 w-4 h-4" style="width: 1rem; height: 1rem" />
          <span v-html="label" />
        </a>
      </li>
      <li class="hover:bg-neutral-100 flex items-center px-4 py-2 w-full cursor-pointer" :title="t_('refresh')" @click="(toggle('translations'), toggleDropdown())">
        <AtomIconCheckmark :class="[isEnabled('translations') ? 'text-green-600' : 'text-neutral-200']" class="shrink-0 mr-3 w-4 h-4" />
        <span v-show="isEnabled('translations')">{{ t_('translations-on') }}</span>
        <span v-show="!isEnabled('translations')">{{ t_('translations-off') }}</span>
      </li>
      <li class="hover:bg-neutral-100 flex items-center px-4 py-2 w-full cursor-pointer" :title="t_('reset')" @click="reset">
        <AtomIconPowerSwitch class="shrink-0 text-neutral-500 mr-3 w-4 h-4" />
        <span>{{ t_('disable') }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { setupTranslationPrefixer } from '~/composables/util'
import { useControlPanelStore } from '~/store/control-panel'
import { usePageStore } from '~/store/page'

const route = useRoute()
const controlPanelStore = useControlPanelStore()
const pageStore = usePageStore()

const isOpen = ref(false)

const { t_ } = setupTranslationPrefixer('ControlPanel')

const isEnabled = (name = 'control-panel') => controlPanelStore.isEnabled(name)
const page = computed(() => pageStore.page)

const toggleDropdown = () => {
  isOpen.value = !isOpen.value
}

const urls = computed(() =>
  Object.entries(page.value?.controlPanel || {})
    .filter(([, url]) => typeof url === 'string' && /^https?:\/\//i.test(url))
    .map(([label, url]) => ({ label, url })),
)

onMounted(() => {
  if (/yes|true|1/.test(route.query.cp as string)) {
    controlPanelStore.enable()
  }
})

const reset = () => controlPanelStore.reset()
const toggle = (name: string) => controlPanelStore.toggle(name)
</script>
